import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { FuseConfigService } from '../../../../@fuse/services/config.service';
import { navigation } from '../../../navigation/navigation';
import { RouterModule } from '@angular/router';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FuseDirectivesModule } from '../../../../@fuse/directives/directives';
import { FusePipesModule } from '../../../../@fuse/pipes/pipes.module';
import { FuseSidebarModule } from '../../../../@fuse/components';
import { ContentComponent } from '../../components/content/content.component';
import { NavbarComponent } from '../../components/navbar/navbar.component';
import { NgxPermissionsModule } from 'ngx-permissions';
import { ToolbarComponent } from '../../components/toolbar/toolbar.component';
import { FooterComponent } from '../../components/footer/footer.component';

@Component({
  selector: 'vertical-layout-3',
  templateUrl: './layout-3.component.html',
  styleUrls: ['./layout-3.component.scss'],
  standalone: true,
  imports: [
    RouterModule,
    MatInputModule,
    TranslateModule,
    NgxPermissionsModule,
    MatButtonModule,
    FooterComponent,
    CommonModule,
    FormsModule,
    ToolbarComponent,
    ReactiveFormsModule,
    FuseDirectivesModule,
    FusePipesModule,
    FuseSidebarModule,
    ContentComponent,
    NavbarComponent,
  ],
  encapsulation: ViewEncapsulation.None,
})
export class VerticalLayout3Component implements OnInit, OnDestroy {
  fuseConfig: any;
  navigation: any;

  // Private
  private _unsubscribeAll: Subject<any>;

  /**
   * Constructor
   *
   * @param {FuseConfigService} _fuseConfigService
   */
  constructor(private _fuseConfigService: FuseConfigService) {
    // Set the defaults
    this.navigation = navigation;

    // Set the private defaults
    this._unsubscribeAll = new Subject();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    // Subscribe to config changes
    this._fuseConfigService.config
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe({
        next: (config: any) => {
          this.fuseConfig = config;
        },
      });
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(undefined);
    this._unsubscribeAll.complete();
  }
}
